import http from "./apiServices"
import config from "./config.json"



export const getAnswer =(text)=>{
let id;
    // if(!!sessionStorage.getItem("user_id")){
    //    id =`${sessionStorage.getItem("user_id")}` 
    // }else{
    //     id = "None"
    // }
    // const data ={
    //     "user_id" : `${id}`,
    //     "user_question_text" : `${text}`
    // }
    const data ={
        "user_question" : `${text}`
    }
    return  http.post(`${config.host}/faq`,data)
}